/**
 * 字幕显示：叠在内容区底部，随说随出。
 *
 * 位置贴底居中、半透明黑底白字 —— 和视频播放器的字幕一致，
 * 学生不需要重新学习「字幕在哪」。不挡白板中央的板书区。
 */

import { useRoomStore } from '../stores/roomStore'

export function CaptionLayer() {
  const on = useRoomStore((s) => s.captionOn)
  const lines = useRoomStore((s) => s.captions)
  if (!on || lines.length === 0) return null
  return (
    <div className="caption-layer" aria-live="polite">
      {lines.map((l) => (
        <p key={l.key} className={`caption-line${l.final ? '' : ' partial'}`}>
          <span className="caption-who">{l.name}</span>
          {l.text}
        </p>
      ))}
    </div>
  )
}
